import { Action } from '@ngrx/store';
import { AccessGroup } from '../../../vas/business-objects/access-group/access-group.model';
import { Account } from '../../../vas/business-objects/account/account.model';
import { ControlType } from '../../../vas/business-objects/control-type/control-type.model';
import { Control } from '../../../vas/business-objects/control/control.model';
import { Form } from '../../../vas/business-objects/form/form.model';
import { Group } from '../../../vas/business-objects/group/group.model';
import { Membership } from '../../../vas/business-objects/membership/membership.model';
import { User } from '../../../vas/business-objects/user/user.model';

export const LOAD = '[FormManager] Load';
export const LOAD_SUCCESS = '[FormManager] Load Success';
export const LOAD_FAIL = '[FormManager] Load Fail';

export const LOAD_TEMPLATE = '[FormManager] Load Template';
export const LOAD_TEMPLATE_SUCCESS = '[FormManager] Load Template SUCCESS';
export const LOAD_TEMPLATE_FAIL = '[FormManager] Load Template Fail';

export const SUBMIT_FORM_MANAGER = '[FormManager] Submit Form Manager';
export const SUBMIT_FORM_MANAGER_SUCCESS = '[FormManager] Submit Form Manager Success';
export const SUBMIT_FORM_MANAGER_FAIL = '[FormManager] Submit Form Manager Fail';

export const CANCEL_FORM_MANAGER = '[FormManager] Cancel Form Manager';
export const CANCEL_FORM_MANAGER_SUCCESS = '[FormManager] Cancel Form Manager Success';
export const CANCEL_FORM_MANAGER_FAIL = '[FormManager] Cancel Form Manager Fail';

export const FORM_SELECT = '[FormManager] Form Select';
export const FORM_CREATE = '[FormManager] Form Create';
export const FORM_UPDATE = '[FormManager] Form Update';
export const FORM_REMOVE = '[FormManager] Form Remove';
export const FORM_REFRESH = '[FormManager] Form Refresh';

export const GROUP_SELECT = '[FormManager] Group Select';
export const GROUP_CREATE = '[FormManager] Group Create';
export const GROUP_UPDATE = '[FormManager] Group Update';
export const GROUP_REMOVE = '[FormManager] Group Remove';
export const GROUP_ATTACH = '[FormManager] Group Attach';
export const GROUP_DETACH = '[FormManager] Group Detach';
export const GROUP_COPY = '[FormManager] Group Copy';

export const CONTROL_CREATE = '[FormManager] Control Create';
export const CONTROL_UPDATE = '[FormManager] Control Update';
export const CONTROL_REMOVE = '[FormManager] Control Remove';
export const CONTROL_DUPLICATE = '[FormManager] Control Duplicate';
export const CONTROL_REORDER = '[FormManager] Control Reorder';

export const SUB_CONTROL_CREATE = '[FormManager] Sub Control Create';
export const SUB_CONTROL_UPDATE = '[FormManager] Sub Control Update';
export const SUB_CONTROL_DUPLICATE = '[FormManager] Sub Control Duplicate';
export const CONTROL_FORM_LOAD = '[FormManager] Control Form Load';

export const CONTROL_FORM_SUBMIT = '[FormManager] Control Form Submit';
export const CONTROL_FORM_CANCEL = '[FormManager] Control Form Cancel';
export const CONTROL_FORM_UPDATE = '[FormManager] Control Form Update';
export const CONTROL_FORM_SUB_CONTROL_REORDER = '[FormManager] Control Form Sub Control Reorder';
export const CONTROL_FORM_SUB_CONTROL_REMOVE = '[FormManager] Control Form Sub Control Remove';
export const CONTROL_FORM_UPDATE_CONTROL_TYPE = '[FormManager] Control Form Update Control Type';

export const SUB_CONTROL_FORM_LOAD = '[FormManager] Sub Control Form Load';
export const SUB_CONTROL_FORM_SUBMIT = '[FormManager] Sub Control Form Submit';
export const SUB_CONTROL_FORM_CANCEL = '[FormManager] Sub Control Form Cancel';
export const SUB_CONTROL_FORM_UPDATE = '[FormManager] Sub Control Form Update';

// LOAD ***********************************************************************/

export class Load implements Action {
    readonly type = LOAD;

    constructor(public payload: {accountId: string}) {

    }
}

export class LoadSuccess implements Action {
    readonly type = LOAD_SUCCESS;

    constructor(
        public payload: {
            account: Account,
            membership: Membership,
            accessGroups: Array<AccessGroup>,
            controlTypes: Array<ControlType>,
            controls: Array<Control>,
            forms: Array<Form>,
            groups: Array<Group>,
            user: User
        }
    ) {

    }
}

export class LoadFail implements Action {
    readonly type = LOAD_FAIL;

    constructor(public payload: Error) {

    }
}

// LOAD TEMPLATE **************************************************************/

export class LoadTemplate implements Action {
    readonly type = LOAD_TEMPLATE;

    constructor(public payload: {key: string}) {

    }
}

export class LoadTemplateSuccess implements Action {
    readonly type = LOAD_TEMPLATE_SUCCESS;

    constructor(public payload: {key: string}) {

    }
}

export class LoadTemplateFail implements Action {
    readonly type = LOAD_TEMPLATE_FAIL;

    constructor(public payload: {key: string}) {

    }
}

// GENERAL ********************************************************************/

export class SubmitFormManager implements Action {
    readonly type = SUBMIT_FORM_MANAGER;
}

export class SubmitFormManagerSuccess implements Action {
    readonly type = SUBMIT_FORM_MANAGER_SUCCESS;
}

export class SubmitFormManagerFail implements Action {
    readonly type = SUBMIT_FORM_MANAGER_FAIL;
}

export class CancelFormManager implements Action {
    readonly type = CANCEL_FORM_MANAGER;
}

export class CancelFormManagerSuccess implements Action {
    readonly type = CANCEL_FORM_MANAGER_SUCCESS;
}

export class CancelFormManagerFail implements Action {
    readonly type = CANCEL_FORM_MANAGER_FAIL;
}

// FORM ***********************************************************************/

export class FormSelect implements Action {
    readonly type = FORM_SELECT;

    constructor(public payload: {formId: string | undefined}) {

    }
}

export class FormCreate implements Action {
    readonly type = FORM_CREATE;

    constructor(public payload: {form: Form}) {

    }
}

export class FormUpdate implements Action {
    readonly type = FORM_UPDATE;

    constructor(public payload: {form: Form}) {

    }
}

export class FormRemove implements Action {
    readonly type = FORM_REMOVE;

    constructor(public payload: {form: Form}) {

    }
}

export class FormRefresh implements Action {
    readonly type = FORM_REFRESH;

    constructor(public payload: {form: Form}) {

    }
}

// GROUP **********************************************************************/

export class GroupSelect implements Action {
    readonly type = GROUP_SELECT;

    constructor(public payload: {group: Group | undefined}) {

    }
}

export class GroupCreate implements Action {
    readonly type = GROUP_CREATE;

    constructor(public payload: {group: Group}) {

    }
}

export class GroupUpdate implements Action {
    readonly type = GROUP_UPDATE;

    constructor(public payload: {group: Group}) {

    }
}

export class GroupRemove implements Action {
    readonly type = GROUP_REMOVE;

    constructor(public payload: {group: Group}) {

    }
}

export class GroupAttach implements Action {
    readonly type = GROUP_ATTACH;

    constructor(public payload: {groupId: string}) {

    }
}

export class GroupDetach implements Action {
    readonly type = GROUP_DETACH;

    constructor(public payload: {group: Group}) {

    }
}

export class GroupCopy implements Action {
    readonly type = GROUP_COPY;

    constructor(public payload: {groupId: string}) {

    }
}

// CONTROL*********************************************************************/

export class ControlCreate implements Action {
    readonly type = CONTROL_CREATE;

    constructor(public payload: {control: Control}) {

    }
}

export class ControlUpdate implements Action {
    readonly type = CONTROL_UPDATE;

    constructor(public payload: {control: Control}) {

    }
}

export class ControlRemove implements Action {
    readonly type = CONTROL_REMOVE;

    constructor(public payload: {control: Control}) {

    }
}

export class ControlDuplicate implements Action {
    readonly type = CONTROL_DUPLICATE;

    constructor(public payload: {control: Control}) {

    }
}

export class ControlReorder implements Action {
    readonly type = CONTROL_REORDER;

    constructor(public payload: {from: number, to: number}) {

    }
}

// SUB CONTROL ****************************************************************/

export class SubControlCreate implements Action {
    readonly type = SUB_CONTROL_CREATE;

    constructor(public payload: {control: Control, parentId: string}) {

    }
}

export class SubControlUpdate implements Action {
    readonly type = SUB_CONTROL_UPDATE;

    constructor(public payload: {control: Control, parentId: string}) {

    }
}

export class SubControlDuplicate implements Action {
    readonly type = SUB_CONTROL_DUPLICATE;

    constructor(public payload: {control: Control, parentId: string}) {

    }
}

// CONTROL FORM ***************************************************************/

export class ControlFormLoad implements Action {
    readonly type = CONTROL_FORM_LOAD;

    constructor(public payload: {accountId: string, controlId: string}) {

    }
}

export class ControlFormSubmit implements Action {
    readonly type = CONTROL_FORM_SUBMIT;

    constructor(public payload: {control: Control}) {

    }
}

export class ControlFormCancel implements Action {
    readonly type = CONTROL_FORM_CANCEL;
}

export class ControlFormUpdate implements Action {
    readonly type = CONTROL_FORM_UPDATE;

    constructor(public payload: {control: Control}) {

    }
}

export class ControlFormSubControlReorder implements Action {
    readonly type = CONTROL_FORM_SUB_CONTROL_REORDER;

    constructor(public payload: {from: number, to: number}) {

    }
}

export class ControlFormSubControlRemove implements Action {
    readonly type = CONTROL_FORM_SUB_CONTROL_REMOVE;

    constructor(public payload: {control: Control}) {

    }
}

export class ControlFormUpdateControlType implements Action {
    readonly type = CONTROL_FORM_UPDATE_CONTROL_TYPE;

    constructor(public payload: {controlType: ControlType}) {

    }
}

// SUB CONTROL FORM ***********************************************************/

export class SubControlFormLoad implements Action {
    readonly type = SUB_CONTROL_FORM_LOAD;

    constructor(public payload: {accountId: string, controlId: string, subControlId: string}) {

    }
}

export class SubControlFormSubmit implements Action {
    readonly type = SUB_CONTROL_FORM_SUBMIT;

    constructor(public payload: {control: Control}) {

    }
}

export class SubControlFormCancel implements Action {
    readonly type = SUB_CONTROL_FORM_CANCEL;
}

export class SubControlFormUpdate implements Action {
    readonly type = SUB_CONTROL_FORM_UPDATE;

    constructor(public payload: {control: Control}) {

    }
}

export declare type Actions
    = Load
    | LoadSuccess
    | LoadFail
    | LoadTemplate
    | LoadTemplateSuccess
    | LoadTemplateFail
    | SubmitFormManager
    | SubmitFormManagerSuccess
    | SubmitFormManagerFail
    | CancelFormManager
    | CancelFormManagerSuccess
    | CancelFormManagerFail
    | FormSelect
    | FormCreate
    | FormUpdate
    | FormRemove
    | FormRefresh
    | GroupSelect
    | GroupCreate
    | GroupUpdate
    | GroupRemove
    | GroupAttach
    | GroupDetach
    | GroupCopy
    | ControlCreate
    | ControlUpdate
    | ControlRemove
    | ControlDuplicate
    | ControlReorder
    | SubControlCreate
    | SubControlUpdate
    | SubControlDuplicate
    | ControlFormLoad
    | ControlFormSubmit
    | ControlFormCancel
    | ControlFormUpdate
    | ControlFormSubControlReorder
    | ControlFormSubControlRemove
    | ControlFormUpdateControlType
    | SubControlFormLoad
    | SubControlFormSubmit
    | SubControlFormCancel
    | SubControlFormUpdate
    ;



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/form-manager-page.actions.ts